// extracted by mini-css-extract-plugin
export var flipAvatar = "flipAvatar-module--flipAvatar--yAXBJ";
export var flipBack = "flipAvatar-module--flipBack--t0l0z";
export var flipFront = "flipAvatar-module--flipFront--hqKTZ";
export var flipImage = "flipAvatar-module--flipImage--202XT";
export var flipInner = "flipAvatar-module--flipInner--3bq7n";
export var flipped = "flipAvatar-module--flipped--y-ciZ";